<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Asistencia Campamento">
          <AsistenciaLista @open="open()" @close="close()"></AsistenciaLista>
        </BaseCard>
      </v-col>
    </v-row>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Asistencia',
  components: {
    AsistenciaLista: () => import('../components/AsistenciaLista')
  },
  data: () => ({
    showLoading: true,
    page: {
      title: 'Campamento'
    },
    breadcrumbs: [
      {
        text: 'Reportes',
        disabled: true
      },
      {
        text: 'Asistencia Campamento',
        disabled: true
      }
    ]
  }),
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    }
  }
};
</script>
